import { Component, Inject, Input, OnInit, inject } from "@angular/core";
import {
    MatDialogRef,
    MAT_DIALOG_DATA,
    MatDialogModule
} from "@angular/material/dialog";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { FormsModule } from "@angular/forms";
import { CheckboxComponent } from "@app/shared/components/dsn/checkbox/checkbox.component";
import { SaveWhatsappController } from "@arch/presentation/controllers/save-whatsapp.controller";
import { JwtAuthService } from "@app/shared/services/jwt-auth.service";
import { CompanyEntity } from "@arch/domain/entity/company.entity";
import { DDI_OPTIONS } from "@app/shared/constants/ddi.constants";

@Component({
    selector: "app-edit-whatsapp-dialog",
    imports: [
        SharedMaterialModule,
        SharedDsnModule,
        MatDialogModule,
        FormsModule,
        CheckboxComponent
    ],
    templateUrl: "./edit-whatsapp-dialog.component.html",
    styleUrl: "./edit-whatsapp-dialog.component.scss"
})
export class EditWhatsappDialogComponent implements OnInit {
    public defaultValue: string = "55";
    public prefixes = DDI_OPTIONS;
    public currentDdi: {
        label: string;
        value: string;
        mask: string;
        country: string;
    };
    private saveWhatsappController = inject(SaveWhatsappController);
    private defaultNumber: string = "+55";
    @Input() loading: boolean = false;

    tooltipMessage: string =
        'Você pode alterar esta configuração a qualquer momento acessando "Central de Dashes > Configurações".';

    constructor(
        private dialogRef: MatDialogRef<EditWhatsappDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            whatsapp?: string;
            showMessage?: boolean;
            company?: CompanyEntity;
        }
    ) {}

    ngOnInit(): void {
        this.currentDdi = this.prefixes[0];
    }

    onClose(): void {
        this.dialogRef.close();
    }

    public onChangeDDI(ddi: string): void {
        this.currentDdi = this.prefixes.find(
            (item: {
                label: string;
                value: string;
                mask: string;
                country: string;
            }) => item.value === ddi
        );
    }

    public onNoteShowMore(): void {
        if (this.defaultNumber) {
            this.defaultNumber = null;
        } else {
            this.defaultNumber = "00000000000";
        }
    }
    async onSave(): Promise<void> {
        this.loading = true;

        if (this.data.company) {
            const whatsapp = !this.data.whatsapp
                ? "00000000000"
                : `${this.currentDdi.value}:${this.data.whatsapp.replace(/\D/g, "")}`;

            this.data.company.setAccountingWhatsapp(
                this.defaultNumber ? this.defaultNumber : whatsapp
            );

            await this.saveWhatsappController.execute(
                this.data.company.props.accounting
            );
        }

        this.dialogRef.close();

        this.loading = false;
    }

    onChange(event: any): void {
        this.onNoteShowMore();
    }
}
